import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const assignSegmentPriceBookItems = createAsyncThunk("assignSegmentPriceBookItems", async ({ id, values }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`price-book/segment/${id}/items`, values);

		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const SegmentPriceBookItemAssignSlice = createSlice({
	name: "SegmentPriceBookItemAssignSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(assignSegmentPriceBookItems.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(assignSegmentPriceBookItems.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(assignSegmentPriceBookItems.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default SegmentPriceBookItemAssignSlice.reducer;
